;(function($){
	/**
	 * helper function for tipping delay
	 */
	var timer = 0;
	function tipDelay(callback, ms) {
		clearTimeout(timer);
		timer = setTimeout(callback, ms);
	};

	/**
	 * Autocomplete function for searchbox
	 * @param options
	 */
	$.fn.sgAutocomplete = function(options){

		var defaults = {
			shopId: null,
			suggest_script_url: '', 		// path to webroot/scripts/cloudsearch_suggest.php
			cloudsearch_url: null,			// url to cloudsearch api with lang setting
			tipDelay: 200,					// delay between keyup events (keyups in the delay time gets ignored)
			resultsSelector: ''				// selector for the <ul> dom node (for display the results)
		};

		options = options || {};
		options = $.extend({}, defaults, options);

		var $results,
			prevInputVal,
			request,
			lastResponse,
			$autocomplete = this;

		$autocomplete.on('keyup focus', function(e) {

			var input = this;

			// Input value didn't change, no need for new request
			if (input.value.trim() == prevInputVal) {
				// But make sure results are displayed (again). only if input have text in
				if ($results && lastResponse && lastResponse.data.length && prevInputVal != '') {
					$results.show();
				}
				return;
			}

			function createSuggestionEntry(suggestion) {
				return $('<li>').append(
						$('<a>', {
							html: suggestion,
							href: "#",
							class: "no-sg-action sg"
						}).click(function(e){
							e.preventDefault();
							input.value = suggestion;
							$results.hide();
							$('#search').submit();
						})
					).append(
						$('<a>', {
							'html': '&#8598;',
							'href': '#',
							'class': 'no-sg-action suggestion-copy'
						}).click(function(e) {
							e.preventDefault();
							input.value = suggestion;
							input.focus();
							$results.hide();
						})
					)
			}

			tipDelay(function() {

				// Cancel last request
				if (request && request.readyState != 4) {
					request.abort();
				}

				if (input.value.length >= 2) {

					request = $.shopgate.ajax({
						type: options.suggest_script_url.match('^sgapi:') ? 'POST' : 'GET',
						url: options.suggest_script_url,
						data: {
							shopId: options.shopId,
							suggest: input.value.trim(),
							apiUrl: options.cloudsearch_url
						},
						dataType: 'json',
						success: function(response){

							lastResponse = response;

							if(input.value.length < 1) {
								return;
							}
							if (!$results) $results = $(options.resultsSelector);

							if (response.success && response.data && response.data.length){

								var entries = [];
								for (var i = 0, len = response.data.length; i < len; ++i) {
									entries.push(createSuggestionEntry(response.data[i]));
								}

								$results.html(entries).show();

							} else {
								$results.html('').hide();
							}
						}
					});

				} else {
					if (!$results) $results = $(options.resultsSelector);

					if ($results.length){
						$results.html('').hide();
					}
				}

				prevInputVal = input.value;

			}, options.tipDelay);

		});

		// Hide results when clicking somewhere else
		$(document).on('click', function(event) {
			if ($results && !$(event.target).closest($results).length && !$(event.target).closest($autocomplete).length) {
				$results.hide();
			}
		});

		return this;

	}
})(jQuery);




// WEBPACK FOOTER //
// ./Library/1.0/common/jquery.shopgate-autocomplete.js